module.exports = __webpack_public_path__ + "img/giro.761ca13b.svg";